import {
    COMPANY_COUNTRIES_LOAD,
    COMPANY_OPPONENT_COUNTRIES_LOAD,
    COMPANY_TIMELINE_LOAD,
    COMPANY_TIMELINE_LOAD_SUCCESS
} from "../actions/actionTypes";

const companyReducer = (state = {}, action) => {
    switch (action.type) {
        case COMPANY_TIMELINE_LOAD:
            return {
                ...state,
                loading: true
            };
        case COMPANY_TIMELINE_LOAD_SUCCESS:
            return {
                ...state,
                loading: false,
                timeline: action.payload
            };
        case COMPANY_COUNTRIES_LOAD:
            return {
                ...state,
                companyCountries: action.payload
            };
        case COMPANY_OPPONENT_COUNTRIES_LOAD:
            return {
                ...state,
                companyOpponentCountries: action.payload
            }
        default:
            return state;
    }
};

export default companyReducer;
